import { ClinicActionTypes } from "./type";

export const select_city = (data:any) => ({ type: ClinicActionTypes.SELECT_CITY, data });

export const select_clinic = (data:any) => ({ type: ClinicActionTypes.SELECT_CLINIC, data });

export const set_point = (data:any) => ({ type: ClinicActionTypes.SET_POINT, data });

